import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";


function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [about, updateAbout] = useState("active1");
  const [work, updateWork] = useState("");
  const [projects, updateProjects] = useState("");
  const [resume, updateResume] = useState("last-nav");
  const [navColour, updateNavbar] = useState(false);
  const location = useLocation();


  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }


  useEffect(()=>{
    let pathname = location.pathname;
    if(pathname === '/experience' || pathname === '/experience/truliacareinsights' || pathname === '/experience/kratinportal' || pathname === '/experience/kratinbranding' || pathname === '/experience/monalis'){
      updateExpanded(false);
      updateAbout("first-nav");
      updateWork("active");
      updateProjects("last-nav");
      updateResume("last-nav");
    } else if(pathname === '/contact'){
      updateExpanded(false);
      updateAbout("first-nav");
      updateWork("");
      updateProjects("last-nav");
      updateResume("active2");
    } else if(pathname === "/"){
      updateExpanded(false);
      updateAbout("active1");
      updateWork("");
      updateProjects("last-nav");
      updateResume("last-nav");
    } else if(pathname === "/project" || pathname === "/project/ecanteen" || pathname === "/project/healthpredictor" || pathname === "/project/videochat" || pathname === "/project/adwyzors" || pathname === "/project/ecommerce"){
      updateExpanded(false);
      updateAbout("first-nav");
      updateWork("");
      updateProjects("active2");
      updateResume("last-nav");
    }
  },[]);

  window.addEventListener("scroll", scrollHandler);
  
  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={"navbar"}
    >
      <Container className="nav-cont">
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item className={about}>
              <Nav.Link as={Link} to="/" 
      //         onClick={() =>{
      //           updateExpanded(false);
      // updateAbout("active1");
      // updateWork("");
      // updateProjects("");
      // updateResume("last-nav");
      //         } }  
              >
                About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={work}>
              <Nav.Link 
                as={Link}
                to="/experience"
      //           onClick={() =>{
      //             updateExpanded(false);
      // updateAbout("first-nav");
      // updateWork("active");
      // updateProjects("");
      // updateResume("last-nav");
      //           }}
              >
                Experience
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={projects}>
              <Nav.Link
                as={Link}
                to="/project"
                
                // onClick={() =>{
                //   updateExpanded(false);
                //   updateAbout("first-nav");
                //   updateWork("");
                //   updateProjects("active");
                //   updateResume("last-nav");
                // }}
              >
                Projects
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item className={resume}>
              <Nav.Link
                as={Link}
                to="/contact"
                
      //           onClick={() =>{
      //             updateExpanded(false);
      // updateAbout("first-nav");
      // updateWork("");
      // updateProjects("");
      // updateResume("active2");
      //           }}
              > Contact
              </Nav.Link>
            </Nav.Item> */}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
